import { Folder } from 'lucide-react';

import { FeatureFindState } from './state';
import { lang } from '@lang';
import { useNavigate } from 'react-router-dom';
import { appMode, ContentPanelMode, ContextPanelMode, pushContextPanel, selectCustomerFeatureFindState, selectNavigation, setContentPanelMode, useAppDispatch, useAppSelector } from '@state';
import { Feature, FeatureHoookParams } from '..';

type UseFindCustomerFeatureParams = FeatureHoookParams;
export const useFindCustomerFeature = (_params: UseFindCustomerFeatureParams = {}): Feature<FeatureFindState> => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const appNav = useAppSelector(selectNavigation);
	const findCustomer = useAppSelector(selectCustomerFeatureFindState);

	return {
		name: 'findCustomer',
		label: lang.customer.label.findCustomer,
		shortcut: '',
		tooltip: lang.customer.tooltip.clickToFindCustomer,
		icon: (props = {}) => <Folder {...props} />,
		disabled: false,
		value: findCustomer,
		hidden: appNav.appMode === appMode.view,
		handler: () => {
			// Set find-customer UI state before navigating so the content panel
			// switches immediately. The navigate('/r') triggers the standard
			// app.tsx -> setNavigation flow which clears email/designId.
			dispatch(setContentPanelMode(ContentPanelMode.findCustomer));
			dispatch(pushContextPanel({ mode: ContextPanelMode.FindCustomerProperties, temporary: true }));
			navigate('/r');
		}
	};
};


